const Items = [
    {
        id: 1,
        name: "BBQ Pizza",
        desc: "Smoky BBQ sauce, grilled chicken, red onions, and mozzarella.",
        image: "https://images.pexels.com/photos/315755/pexels-photo-315755.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        price: 11.99
    },
    {
        id: 2,
        name: "Supreme Pizza",
        desc: "Loaded with pepperoni, sausage, bell peppers, olives, and onions.",
        image: "https://images.pexels.com/photos/1146760/pexels-photo-1146760.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        price: 13.99
    },
    {
        id: 3,
        name: "Canadian Pizza",
        desc: "Ham, bacon, and mushrooms on a classic tomato sauce base.",
        image: "https://images.pexels.com/photos/1653877/pexels-photo-1653877.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        price: 12.99
    },
    {
        id: 4,
        name: "Veggie Pizza",
        desc: "Fresh garden vegetables on a rich tomato sauce with mozzarella.",
        image: "https://images.pexels.com/photos/1260968/pexels-photo-1260968.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        price: 9.99
    },
    {
        id: 5,
        name: "Jalapeño Pizza",
        desc: "Spicy jalapeños, ground beef, and mozzarella for the bold.",
        image: "https://images.pexels.com/photos/708587/pexels-photo-708587.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        price: 12.50
    },
    {
        id: 6,
        name: "Pepperoni Pizza",
        desc: "A classic favourite loaded with generous slices of pepperoni.",
        image: "https://images.pexels.com/photos/825661/pexels-photo-825661.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&dpr=1",
        price: 14.50
    }
];

export default Items;
